import React from 'react';
import { Typography, Flex } from 'components';
import styled from 'styled-components';
import { t } from 'i18next';

const StyledFlex = styled(Flex)`
  opacity: 0.8;
`;

export const Spinner = () => {
  return (
    <StyledFlex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Typography.P variant="h2" color="dark">
        {t('common.loading')}...
      </Typography.P>
    </StyledFlex>
  );
};
